import e, { Fragment as t } from "react";
import { Breadcrumb as r } from "antd";
import { withRouter as n, NavLink as o } from "react-router-dom";
import * as a from "@ant-design/icons";
import "./index.scss.js";
var m = n(function (_ref) {
  var n = _ref.routeList,
      m = _ref.location;
  var c = n.find(function (e) {
    return e.route && e.route === m.pathname;
  }),
      i = c ? function (e) {
    var t = {},
        r = [e];
    n.forEach(function (e) {
      t[e.id] = e;
    });

    var o = function o(e) {
      var n = t[e.id].pid;
      n && (r.push(t[n]), o(t[n]));
    };

    return o(e), r;
  }(c).reverse() : [n[0]];
  return e.createElement(r, {
    className: "fast-nav"
  }, function (n) {
    return n.map(function (m, c) {
      var i = m && e.createElement(t, null, m.icon && a[m.icon] ? e.createElement(a[m.icon], {
        style: {
          marginRight: "4px"
        }
      }) : null, m.name);
      return m && e.createElement(r.Item, {
        key: c
      }, n.length - 1 !== c ? e.createElement(o, {
        to: m.route || "#"
      }, i) : i);
    });
  }(i));
});
export default m;